export class Notification {
  Id: number;
  Content: string;
  Department: string;
  Type: number;
  Date: Date;
  IsRequired: boolean;
}
